import React from "react";
import "./loader.css";

const SpinningLoader = () => {
  return (
    <div className="loader-container">
      <span className="loader"></span>
    </div>
  );
};

export default SpinningLoader;
